module.exports = __webpack_public_path__ + "static/media/1001000HG.3f7818d3.jpg";